import { Accordion, AccordionDetails, AccordionSummary, Box, Link, Typography} from '@mui/material';
import FilingSchedule from '../../../../../types/filers/fillingSchedule';
import FilingScheduleTable from './FilingScheduleTable';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import OtherReportsTable from './OtherReportsTable';
import EmergencyIcon from '@mui/icons-material/Emergency';

interface Props {
    schedule?: FilingSchedule[]
    previousSchedule?: FilingSchedule[]
}

const LegislativeCandidates = (props: Props): JSX.Element => {

    return (
        <Box>
            <Typography variant="h6" gutterBottom fontWeight={600}>
                Legislative Candidates
            </Typography>
            <Typography variant="body1" component={'p'} gutterBottom>
                Candidates running for State Senate or State Representative are required to register with OCPF (click <Link underline="none" href="https://www.ocpfreporter.us/OnlineOrganization/" target="_blank">here</Link> to register).
            </Typography>
            <Typography variant="body1" component={'p'} marginTop={2} marginBottom={2}>
                Legislative candidates are required to file the following Campaign Finance Reports.
            </Typography>

            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography fontWeight={'bold'} variant={'subtitle1'}>Current Filing Schedule</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <FilingScheduleTable schedules={props.schedule || []} />
                    <Typography variant='body2' marginTop={1.5} ><EmergencyIcon sx={{ fontSize: 12 }} />&nbsp;In addition to filing deposit reports, expenditures must be clarified on the schedule above.</Typography>
                    <Typography marginTop={4} variant="subtitle2" fontWeight={'bold'} marginBottom={1}><u>Other Reports</u></Typography>
                    <OtherReportsTable isLeg={true} />
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography fontWeight={'bold'} variant={'subtitle1'}>Previous Filing Schedule</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <FilingScheduleTable schedules={props.previousSchedule || []} />
                </AccordionDetails>
            </Accordion>

        </Box>
    );
};

export default LegislativeCandidates;